<section class="ds-modal ds-confirmation-modal" aria-labelledby="ds_confirmation_modal_title">
    <div class="ds-modal__icon" [ngClass]="'ds-modal__icon--' + theme">
        <mat-icon fontSet="material-symbols-rounded">{{ theme | dsBaseModalIcon }}</mat-icon>
    </div>

    <div class="ds-modal__header">
        <h2 id="ds_confirmation_modal_title" class="ds-modal__title">{{ modalSettings.headerText ?? '' }}</h2>

        <ng-container *ngIf="modalSettings.bodyText">
            <p class="ds-modal__description">
                {{ modalSettings.bodyText }}
            </p>
        </ng-container>
    </div>

    <div class="ds-modal__footer ds-modal__footer--full-width">
        <ds-button [label]="modalSettings.cancelText ?? 'Cancel'" size="lg" theme="secondary-gray" (buttonClick)="onCancel()"></ds-button>
        <ds-button
            [label]="modalSettings.confirmText ?? 'Confirm'"
            size="lg"
            [isDestructive]="theme === 'error'"
            theme="primary"
            (buttonClick)="onConfirm()"
        ></ds-button>
    </div>
</section>
